<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/cerfa-icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Édition automatique des CERFAS</h3>
      <p class="dark-gray no-margin text-sm">
        Remplissez les informations nécessaires pour générer automatiquement vos documents
        <span class="bold">CERFA</span> à la clôture du scrutin.
      </p>
    </div>
  </div>

  <div class="flex flex-column gap-20">
    <div class="p-20 bg-white border-box">
      <!-- <div style="display: grid; grid-template-columns: 20% 38% 38%; gap: 20px; width: 100%;"> -->
      <div class="flex w-full content-between gap-20">
        <div style="width: 16%;">
          <p class="dark-blue no-margin bold">
            Progression de la validation
          </p>
          <p class="text-sm mb-10" [ngClass]="validatedCategoriesCount === 5 ? 'strong-green' : 'dark-gray'">
            {{validatedCategoriesCount}} / 5 sections validées
          </p>
        </div>

        <div style="width: 42%;">
          <p class="dark-blue no-margin bold">
            Souhaitez-vous activer l’édition automatique des CERFA ?
          </p>
          <p class="dark-gray text-sm mb-10">
            Pour simplifier vos démarches à l’issue de
            l’élection, nous vous invitons à renseigner les informations nécessaires à la génération automatique des
            CERFA. Cette étape permet de produire, à la clôture du scrutin, des documents réglementaires conformes,
            intégrant les résultats, la répartition des sièges et les mentions obligatoires, sans ressaisie manuelle.
          </p>
        </div>

        <div style="width: 42%;">
          <p class="dark-blue no-margin bold">
            Vérification des données CERFA ?
          </p>
          <p class="dark-gray text-sm mb-10">
            Les informations demandées ci-dessous sont nécessaires à la génération
            automatique des CERFA à la clôture du scrutin. Nous vous recommandons de les renseigner avec attention afin
            de garantir la conformité des documents réglementaires qui seront produits à l’issue de l’élection Ces
            données pourront être vérifiées et ajustées avant la validation finale du scrutin.
          </p>
        </div>
      </div>

      <div>
        <div id="progress-bar" class="mt-20"
          style="width: 100%; background-color: #e0e0e0; border-radius: 8px; height: 24px; overflow: hidden;">
          <div [style.width.%]="verificationPercentage"
            [style.background]="verificationPercentage === 100 ? 'linear-gradient(90deg, #63BA67 0%, #7BC87F 100%)' : 'linear-gradient(90deg, #4A90E2 0%, #5BA3F5 100%)'"
            style="height: 100%; transition: width 0.3s ease, background 0.3s ease; display: flex; align-items: center; justify-content: center;">
            <span *ngIf="verificationPercentage > 0" style="color: white; font-weight: bold; font-size: 12px;">{{
              verificationPercentage }}%</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="needCerfa == false" class="bg-white p-20 flex flex-column gap-20">
      <div class="flex content-center gap-20">
        <img src="assets/clouds-icon.svg" alt="list">
        <img src="assets/ballot-icon.svg" alt="list">
        <img src="assets/clouds-icon.svg" alt="list">
      </div>
      <div>
        <h2 class="dark-blue no-margin text-center mb-5">Vous pouvez passer directement à l'étape suivante.</h2>
        <p class="mb-20 grey no-margin text-center text-sm">
          Le protocole d'accord préélectoral ne sera pas généré automatiquement.
        </p>
      </div>
      <div class="margin-center w-fit">
        <button class="action-button" (click)="goToPollCreation()">Passer à la création du scrutin</button>
      </div>
    </div>

    <div *ngIf="needCerfa" class="flex flex-column gap-20">
      <app-cerfa-information-verification [(venue)]="papValues.venue" (editRequested)="onCerfaEditRequested('election-information')"
        (validated)="onValidatedComponentsChange(0)"></app-cerfa-information-verification>
      <app-cerfa-length-verification [(termLength)]="papValues.termLength" [(headcount)]="papValues.headcount"
        [(round)]="papValues.round" (validated)="onValidatedComponentsChange(1)"
        (editRequested)="onCerfaEditRequested('length-and-colleges')"></app-cerfa-length-verification>
      <app-cerfa-lists-verification [(commonLists)]="papValues.commonLists" (editRequested)="onCerfaEditRequested('election-lists')"
        (validated)="onValidatedComponentsChange(2)"></app-cerfa-lists-verification>
      <app-cerfa-sirets-verification [(sirets)]="papValues.sirets" (editRequested)="onCerfaEditRequested('election-sirets')"
        (validated)="onValidatedComponentsChange(3)"></app-cerfa-sirets-verification>
      <app-cerfa-contact-verification [(contact)]="papValues.contact" (editRequested)="onCerfaEditRequested('contact-information')"
        (validated)="onValidatedComponentsChange(4)"></app-cerfa-contact-verification>

    </div>

  </div>

</div>